import { Coordinate } from "./Coordinate";

export class CartesianCoordinate extends Coordinate {
  x: number = 0;
  y: number = 0;

  constructor() {
    super();
  }
}
